import { render, staticRenderFns } from "./SAASEvidenceList.vue?vue&type=template&id=deebe372"
import script from "./SAASEvidenceList.vue?vue&type=script&lang=js"
export * from "./SAASEvidenceList.vue?vue&type=script&lang=js"
import style0 from "./SAASEvidenceList.vue?vue&type=style&index=0&id=deebe372&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports